import { render } from "./EditorBoxExtras.vue?vue&type=template&id=1a2b9dc6&scoped=true"
import script from "./EditorBoxExtras.vue?vue&type=script&lang=js"
export * from "./EditorBoxExtras.vue?vue&type=script&lang=js"

import "./EditorBoxExtras.vue?vue&type=style&index=0&id=1a2b9dc6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a2b9dc6"

export default script